var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBloodPressure(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "512.000000pt",
    height: "512.000000pt",
    viewBox: "0 0 512.000000 512.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,512.000000) scale(0.100000,-0.100000)",
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2495 4947 c-49 -23 -343 -339 -600 -647 -673 -806 -1099 -1583 -1164 -2125 -63 -521 143 -1092 533 -1478 566 -561 1411 -695 2122 -337 175 88 298 175 443 315 213 206 355 420 455 687 69 186 116 442 116 633 -2 541 -360 1280 -1033 2128 -221 279 -631 741 -713 803 -42 32 -114 41 -159 21z m362 -1998 c15 -6 38 -20 51 -32 12 -11 104 -168 205 -349 l181 -327 222 -3 c207 -3 225 -4 250 -24 53 -39 69 -71 69 -134 0 -63 -16 -95 -69 -134 -26 -20 -43 -21 -299 -24 -150 -2 -286 0 -304 3 -58 11 -88 50 -218 286 -70 126 -132 226 -136 222 -5 -5 -122 -249 -259 -543 -206 -438 -258 -541 -287 -567 -59 -54 -144 -56 -203 -6 -22 18 -74 112 -176 314 l-144 289 -165 0 c-189 0 -216 7 -261 66 -24 31 -29 47 -29 95 0 62 17 94 69 133 26 20 43 21 259 24 128 2 246 0 264 -3 61 -11 90 -49 187 -243 l92 -184 249 528 c137 291 259 543 271 560 41 56 116 78 181 53z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBloodPressure);
export default __webpack_public_path__ + "static/media/blood-pressure.17540828d2763b2c76aeac96a4d3fdd3.svg";
export { ForwardRef as ReactComponent };